import { render } from "./message.html?vue&type=template&id=00e7f279&scoped=true&external"
import script from "./message.ts?vue&type=script&lang=js&external"
export * from "./message.ts?vue&type=script&lang=js&external"

import "./message.scss?vue&type=style&index=0&id=00e7f279&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00e7f279"],['__file',"src/view/message/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "00e7f279"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('00e7f279', __exports__)) {
    api.reload('00e7f279', __exports__)
  }
  
  module.hot.accept("./message.html?vue&type=template&id=00e7f279&scoped=true&external", () => {
    api.rerender('00e7f279', render)
  })

}


export default __exports__